import { Box } from 'components/elements'
import { CSS } from 'theme'
import { ShimmerCss, TitleCss } from '.'

interface TextShimmerProps {
  css?: CSS
}

export const TextShimmer = ({ css }: TextShimmerProps) => {
  return (
    <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2', ...css }}></Box>
  )
}
